/* The numbers under the battle board, and what each column means (owner, 2026-09-16).

   The server's trace carries, per sub-round and per side, `damage_taken` (what landed on the
   units, after defence and the overkill cap), `wall_taken` (what a standing wall soaked — while a
   wall stands every strike but the Dog's goes into it and nothing reaches a unit), `damage_blocked`
   (what the units' defence ate) and `deaths`. The first table folded the wall into "received", so
   a siege's opening sub-round read *received 46,872 · blocked 0 · deaths 0* over a wall that had
   just eaten all of it, and every row was one sub-round of ten with no line saying what the round
   came to — 35 tanks "only did 64k". Both are answered here: the wall's share is *blocked* (it is
   damage that never reached a unit, which is what blocked means), the received column is what the
   units took, and `roundTotals` is the line the reader was adding up by hand. */

const sumFor = (entry, key, ofTeam, teamOfId) =>
  Object.entries(entry).reduce(
    (sum, [id, values]) => (teamOfId(id) === ofTeam ? sum + Number(values[key] || 0) : sum),
    0
  )

const enemyOf = (teamKey) => (teamKey === "human" ? "zombie" : "human")

/* One sub-round for one side. `dealt` is everything the side's blows landed on the enemy, wall
   included; `taken` is what reached its own units; `wall` is what its wall soaked, reported on
   its own so the cell can say so; `blocked` is defence plus wall. */
export const subRoundRow = (entry, teamKey, teamOfId) => {
  const enemy = enemyOf(teamKey)
  const wall = sumFor(entry, "wall_taken", teamKey, teamOfId)
  return {
    engaged: sumFor(entry, "engaged", teamKey, teamOfId),
    dealt: sumFor(entry, "damage_taken", enemy, teamOfId) + sumFor(entry, "wall_taken", enemy, teamOfId),
    taken: sumFor(entry, "damage_taken", teamKey, teamOfId),
    wall,
    blocked: sumFor(entry, "damage_blocked", teamKey, teamOfId) + wall,
    deaths: sumFor(entry, "deaths", teamKey, teamOfId),
  }
}

/* The round: every figure summed over the sub-rounds, except `engaged`, which is a headcount and
   reads as the most the side ever had on the field. */
export const roundTotals = (subRounds, teamKey, teamOfId) =>
  subRounds.reduce(
    (total, entry) => {
      const row = subRoundRow(entry, teamKey, teamOfId)
      return {
        engaged: Math.max(total.engaged, row.engaged),
        dealt: total.dealt + row.dealt,
        taken: total.taken + row.taken,
        wall: total.wall + row.wall,
        blocked: total.blocked + row.blocked,
        deaths: total.deaths + row.deaths,
      }
    },
    { engaged: 0, dealt: 0, taken: 0, wall: 0, blocked: 0, deaths: 0 }
  )
